
import Vue, { PropType } from 'vue'
import { User } from "@/model/User";
import moment from 'moment'

const ONE_DAY = 24 * 60 * 60;

interface Data {
  timer: number;
  timerInterval: ReturnType<typeof setInterval> | null;
}

export default Vue.extend({
  name: "ParticipateButton",

  props: {
    user: {
      type: Object as PropType<User>,
    },
    participationIsActive: {
      type: Boolean
    },
    canUserParticipate: {
      type: Boolean
    },
    wrapperClass: {
      type: String
    },
    endAt: {
      type: String
    },
  },

  computed: {
    formattedTimer: function (): string {
      if (this.timer <= 0) return '';

      return moment.utc(this.timer * 1000).format("[Left time]: HH:mm:ss");
    }
  },

  methods: {
    initializeTimer: function() {
      const diff = moment(this.endAt).diff(moment(), 'seconds')
      if (diff > ONE_DAY) return;

      this.timer = moment(this.endAt).diff(moment(), 'seconds');
      this.timerInterval = setInterval(() => {
        this.timer = moment(this.endAt).diff(moment(), 'seconds');
        if (this.timerInterval && this.timer <= 0) {
          clearInterval(this.timerInterval);
        }
      }, 1000)
    },
  },

  mounted() {
    this.initializeTimer();
  },

  data: (): Data => ({
    timer: 0,
    timerInterval: null,
  })
})
